<template>
  <div>
    <header-nav :navInfo="navInfo"
                @backFunc="backFunc"></header-nav>
    <div>
      <van-form ref="formRef"
                class="form"
                validate-trigger="onSubmit"
                @submit="submit">
        <van-cell-group inset>
          <van-field v-model="formData.mobile"
                     name="mobile"
                     icon-prefix="field-icon"
                     label='新手机号'
                     placeholder="请输入手机号"
                     :rules="rules.mobile" />

          <van-field v-model="formData.code"
                     name="code"
                     label='验证码'
                     icon-prefix="field-icon"
                     placeholder="请输入验证码"
                     :rules="rules.code">
            <template #button>
              <div round
                   :disabled="getCodeIng"
                   class="get-code-btn"
                   @click="getCode">{{ getCodeIng ? countdown + 's后再次获取' : '获取验证码' }}</div>
            </template>
          </van-field>
        </van-cell-group>

        <div style="margin: 16px;">
          <van-button round
                      block
                      color="#34D1BC"
                      type="primary"
                      native-type="submit">
            确认修改
          </van-button>
        </div>

      </van-form>
    </div>
  </div>
</template>

<script>
import { mobilePettern } from '@/utils/pattern'
import { changePhoneReq, sendChangeSms } from '@/api/user'
import { Notify } from 'vant'

import HeaderNav from '@/components/head-nav.vue'
export default {
  name: 'changePhone',
  components: { HeaderNav },
  data () {
    return {
      navInfo: { tit: '更换手机' },
      formData: {
        mobile: '',
        code: ''
      },
      getCodeIng: false,
      countdown: 60,
      rules: Object.freeze({
        mobile: [
          { required: true, message: '请输入手机号' },
          { pattern: mobilePettern, message: '请输入正确的手机号' }
        ],
        code: [
          { required: true, message: '请输入验证码' }
        ],
      })
    }
  },
  beforeDestroy () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      this.timer && clearInterval(this.timer)
      this.timer = null
    },
    // 注册获取验证码
    getCode () {
      if (this.getCodeIng) return;

      this.$refs.formRef.validate('mobile').then(async () => {

        this.clearTimer()
        this.getCodeIng = true

        const res = await sendChangeSms({ tel: this.formData.mobile, codeType: 'mobile' })
        const resData = res.data
        if (resData.code === 200) {

          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown == 0) {
              this.getCodeIng = false
              this.countdown = 60
              this.clearTimer()
            }
          }, 1000)
        }
      })
    },
    // 表单验证并提交
    submit () {
      // if (!this.acceptTheRule) {
      //   Notify({ type: 'danger', message: '请阅读用户协议后勾选' });
      //   return;
      // }

      this.changePhone()

    },
    async changePhone () {
      const params = {
        tel: this.formData.mobile,
        password: this.formData.password,
        smsCode: this.formData.code,
      }
      const res = await changePhoneReq(params)
      const resData = res.data
      if (resData.code === 200) {
        Notify({ type: 'success', message: resData.data });
        this.resetForm()
      }
    },
    resetForm () {
      this.formData.mobile = ''
      this.formData.password = ''
      this.formData.code = ''
      this.formData.passwordAgain = ''
      this.$refs.formRef.resetValidation()
    },
    backFunc () {
      this.$router.back();
    }
  }
}

</script>

<style lang="stylus" scoped>
.formIcon
  width 24px

.icon-eye
  width 15px
  height 15px

.form
  padding 0 10px

  >>> .van-field__left-icon .field-icon
    font-size 22px

  >>> .van-field__right-icon .field-icon
    font-size 16px

  .get-code-btn
    display inline
    padding 6px 8px
    font-size 10px
    border 1px solid #34D1BC
    border-radius 25px
    color #34D1BC
    background #fff
    cursor pointer
</style>